module.exports = __webpack_public_path__ + "static/media/CTLI_4-147w.65d219ee.png";